/*
 * METHODE — Bewegung fuer sections/rxk-me-*.liquid.
 *
 * [data-me-loader]  Text-Pre-Loader: Logo, Zeile 1, Zeile 2, dann faehrt er weg.
 *                   Klick ueberspringt. data-einmal="true": nur einmal je Sitzung.
 * [data-me-szene]   klebende Buehne: --p = wie weit durchgescrollt
 * [data-me-bilder]  Bildwechsel im Aufmacher (Knoepfe, Zaehler, automatisch);
 *                   Videos laufen nur, solange ihr Motiv aktiv und sichtbar ist
 * [data-me-linien]  die Zeile naechst der Bildschirmmitte wird .ist-aktiv
 * [data-me-rein]    blendet einmal ein
 * [data-me-navpill] erscheint nach dem Aufmacher
 * Horizon scrollt ab 990px in .page-wrapper, daher scroll mit capture.
 */
(() => {
  if (window.__rxkMethode) return;
  window.__rxkMethode = true;

  const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const start = () => {
    document.documentElement.classList.add('me-js');

    /* Pre-Loader */
    const loader = document.querySelector('[data-me-loader]');
    if (loader && !document.documentElement.classList.contains('me-ohne-loader')) {
      const tempo = parseFloat(loader.dataset.tempo || '1');
      const schritte = [['ist-1', 250], ['ist-2', 1100], ['ist-3', 1800], ['ist-weg', 3200]].map(([k, ms]) => [k, ms * tempo]);
      const timer = [];
      const weg = () => {
        timer.forEach(clearTimeout);
        loader.classList.add('ist-1', 'ist-2', 'ist-3', 'ist-weg');
        setTimeout(() => loader.remove(), 1200);
        try { if (loader.dataset.einmal === 'true') sessionStorage.setItem('rxk-me-loader', '1'); } catch (e) {}
      };
      schritte.forEach(([klasse, ms]) => timer.push(setTimeout(() => (klasse === 'ist-weg' ? weg() : loader.classList.add(klasse)), ms)));
      loader.addEventListener('click', weg);
    }

    /* Einblenden */
    const rein = document.querySelectorAll('[data-me-rein]');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((eintraege) => {
        for (const e of eintraege) if (e.isIntersecting) { e.target.classList.add('ist-drin'); io.unobserve(e.target); }
      }, { rootMargin: '0px 0px -10% 0px' });
      rein.forEach((el) => io.observe(el));
    } else rein.forEach((el) => el.classList.add('ist-drin'));

    /* Bildwechsel */
    const videoPruefer = [];
    document.querySelectorAll('[data-me-bilder]').forEach((box) => {
      const bilder = [...box.querySelectorAll('.me-auftakt__bild')];
      const zahl = box.querySelector('.me-auftakt__zahl');
      if (!bilder.length) return;
      let i = 0;
      // Sichtbarkeit ueber die Lage statt IntersectionObserver: dessen erste
      // Meldung kam beim Laden (Buehne klebt in .page-wrapper) als "nicht
      // sichtbar" und pausierte das Video, bis gescrollt wurde.
      let sichtbar = true;
      const videos = () => bilder.forEach((b, j) => {
        const v = b.querySelector('[data-me-video]');
        if (!v) return;
        // Bei reduzierter Bewegung kein Autoplay: das Vorschaubild bleibt stehen
        if (j === i && sichtbar && !ruhig) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
        else v.pause();
      });
      if (box.querySelector('[data-me-video]')) {
        videoPruefer.push(() => {
          const r = box.getBoundingClientRect();
          const jetzt = r.bottom > 0 && r.top < window.innerHeight;
          if (jetzt !== sichtbar) { sichtbar = jetzt; videos(); }
        });
      }
      const zeige = (n) => {
        i = (n + bilder.length) % bilder.length;
        bilder.forEach((b, j) => b.classList.toggle('ist-aktiv', j === i));
        videos();
        if (zahl) zahl.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(bilder.length).padStart(2, '0');
      };
      zeige(0);
      const sek = parseFloat(box.dataset.sekunden || '0');
      let auto = sek > 0 && bilder.length > 1 && !ruhig ? setInterval(() => zeige(i + 1), sek * 1000) : 0;
      const neu = () => { if (auto) { clearInterval(auto); auto = setInterval(() => zeige(i + 1), sek * 1000); } };
      box.querySelector('[data-me-zurueck]')?.addEventListener('click', () => { zeige(i - 1); neu(); });
      box.querySelector('[data-me-vor]')?.addEventListener('click', () => { zeige(i + 1); neu(); });
    });

    const szenen = [...document.querySelectorAll('[data-me-szene]')];
    const linien = [...document.querySelectorAll('[data-me-linien] .me-linie')];
    const pill = document.querySelector('[data-me-navpill]');
    const auftakt = document.querySelector('.me-auftakt');

    let geplant = false;
    const rechne = () => {
      geplant = false;
      videoPruefer.forEach((f) => f());
      const vh = window.innerHeight;
      if (!ruhig) {
        for (const s of szenen) {
          const r = s.getBoundingClientRect();
          const buehne = s.querySelector('[data-me-buehne]');
          if (!buehne) continue;
          const oben = parseFloat(getComputedStyle(buehne).top) || 0;
          const lauf = Math.max(1, r.height - buehne.offsetHeight);
          s.style.setProperty('--p', Math.min(1, Math.max(0, (oben - r.top) / lauf)).toFixed(4));
        }
      }
      if (linien.length) {
        let beste = null, abstand = Infinity;
        for (const l of linien) {
          const r = l.querySelector('.me-linie__titel').getBoundingClientRect();
          const d = Math.abs(r.top + r.height / 2 - vh * 0.42);
          if (d < abstand) { abstand = d; beste = l; }
        }
        linien.forEach((l) => l.classList.toggle('ist-aktiv', l === beste && abstand < vh * 0.45));
      }
      if (pill) {
        const unten = auftakt ? auftakt.getBoundingClientRect().bottom : 0;
        pill.classList.toggle('ist-sichtbar', unten < vh * 0.9);
      }
    };
    const plane = () => { if (!geplant) { geplant = true; requestAnimationFrame(rechne); } };
    rechne();
    window.addEventListener('scroll', plane, { passive: true, capture: true });
    window.addEventListener('resize', plane);
    window.addEventListener('load', plane);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
